/* eslint-disable default-case */
import log from "loglevel";
import prefix from "loglevel-plugin-prefix";
import ClientContext from "./client-context/ClientContext";
const remoteLogShippingFormat = log => {
  const type = process.env.REACT_APP_TYPE;
  const name = `${process.env.REACT_APP_NAME} ${type ? type : "Web"}`;
  return {
    level: log.level.label,
    logger: log.logger,
    message: log.message,
    stacktrace: log.stacktrace,
    timestamp: log.timestamp,
    app: name,
    version: process.env.REACT_APP_VERSION
  };
};
export const initLogger = () => {
  if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_STAGE === "ppec") {
    const originalFactory = log.methodFactory;
    log.methodFactory = function (methodName, logLevel, loggerName) {
      return function (message, obj) {
        const rawMethod = originalFactory(methodName, logLevel, loggerName);
        if (methodName === "debug") {
          //eslint-disable-next-line
          console.debug(message, obj);
        } else {
          rawMethod(message, obj);
        }
      };
    };
    prefix.reg(log);

    //Apply the custom log pattern
    prefix.apply(log, {
      template: "[%t] [%n] :"
    });
  }
  if ((process.env.NODE_ENV === "production" || process.env.REACT_APP_STAGE === "ppec") && process.env.REACT_APP_NAME === "LLM") {
    const originalFactory = log.methodFactory;
    log.methodFactory = function (methodName, logLevel, loggerName) {
      return function (message, obj) {
        const rawMethod = originalFactory(methodName, logLevel, loggerName);
        if (loggerName === "LiveMessenger events") {
          //eslint-disable-next-line
          rawMethod(message, obj);
        }
      };
    };
    prefix.reg(log);

    //Apply the custom log pattern
    prefix.apply(log, {
      template: "[%t] [%n] :"
    });
  }

  // Setup Environment Logging Level, default to info
  log.setLevel(process.env.REACT_APP_LOG_LEVEL || "debug");
  if (process.env.NODE_ENV === "production") {
    const appName = `${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`;
    prefix.reg(log);

    //Apply the custom log pattern
    prefix.apply(log, {
      template: `[%t] %l (${appName} - %n) :`,
      timestampFormatter(date) {
        return date.toISOString();
      }
    });
  }

  // if (process.env.NODE_ENV === "production") {
  //Apply the remote logger - only for production
  // LD-4195 - the android is getting crash without try... catch...
  try {
    import("loglevel-plugin-remote").then(remote => {
      remote.apply(log, {
        url: `${process.env.REACT_APP_BASE_PLATFORM_URL}community/log`,
        stacktrace: {
          excess: 1
        },
        headers: {
          "x-api-key": ClientContext._apiKey
        },
        format: remoteLogShippingFormat
      });
    });
  } catch (error) {
    // error comes here...
  }
  // }
};
export { log };